import httpAuth from "@/common/http-common";
import { 
  DataContent,
  AlertZone
} from "./expanded-dashboard.types";

class ExpandedDashboardService {
  async getDataset(startDate: string, endDate: string, participantId: number, clientId: number, timezone: string, type?: number) {
    const { data } = await httpAuth().get<DataContent>(
      '/ExpandedDashboard/GetDataset', { params: { 
        startDate: startDate,
        endDate: endDate,
        participantId: participantId,
        type: type,
        clientId: clientId,
        timezone: timezone
      } 
    });
    return data;
  }

  async getAlertZones(alertZoneType: number, clientId: number) {
    const { data } = await httpAuth().get<AlertZone[]>(
      '/ExpandedDashboard/GetAlertZones', { params: { 
        alertZoneType: alertZoneType,
        clientId: clientId
      } 
    });
    return data;
  }
}

export default new ExpandedDashboardService();